import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import { CONTACT } from '../mock';

export default function PaymentCancel() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get('order_id');

  return (
    <main>
      <PageHeader title="Payment Cancelled" breadcrumb="Checkout" />
      <section className="py-20 bg-white">
        <div className="max-w-2xl mx-auto px-6 text-center" data-testid="payment-cancelled">
          <div className="w-20 h-20 mx-auto rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mb-6">
            <XCircle size={40} />
          </div>
          <h1 className="section-title text-3xl md:text-4xl mb-4">No worries — nothing was charged</h1>
          <p className="text-gray-600 mb-2">You cancelled before finishing payment, so your card was not charged.</p>
          {orderId && <p className="text-gray-500 mb-6 text-sm">Draft order: <span className="font-mono">{orderId.slice(0, 8).toUpperCase()}</span></p>}
          <p className="text-gray-600 mb-8">Your cart is still saved. Head back to checkout whenever you're ready.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button onClick={() => nav('/checkout')} className="btn-wrappus text-sm" data-testid="cancel-back-to-checkout">Back to Checkout</button>
            <a href={`tel:${CONTACT.phoneRaw}`} className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white border-2 border-[#ED2E2E] text-[#ED2E2E] font-semibold hover:bg-[#FDF3EC] transition">Order by Phone</a>
          </div>
        </div>
      </section>
    </main>
  );
}
